import {
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  DoughnutController,
  Filler,
  Legend,
  LinearScale,
  LineController,
  LogarithmicScale,
  LineElement,
  PointElement,
  SubTitle,
  Title,
  Tooltip,
} from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";

Chart.register(
  // Controllers
  BarController,
  DoughnutController,
  LineController,

  // Elements
  ArcElement,
  BarElement,
  LineElement,
  PointElement,

  // Scales
  CategoryScale,
  LinearScale,
  LogarithmicScale,

  // Plugins
  Legend,
  Title,
  Tooltip,
  SubTitle,
  Filler,
  zoomPlugin
);

export default Chart;
